{
  "basePath": "/images/editorial/red-thread-v2",
  "width": 1672,
  "height": 941,
  "home": {
    "file": "atlas-frontispiece.webp",
    "alt": {
      "en": "A lone observer faces a brass lens and a tall mirror while a red thread connects the instruments across an open field.",
      "uk": "Самотній спостерігач стоїть перед латунною лінзою та високим дзеркалом; інструменти поєднує червона нитка у відкритому просторі.",
      "ru": "Одинокий наблюдатель стоит перед латунной линзой и высоким зеркалом; инструменты соединяет красная нить в открытом пространстве."
    },
    "caption": {
      "en": "We meet one reality through different lenses and mirrors. Each reveals something—and each can hide what lies outside its frame.",
      "uk": "Ми зустрічаємо одну реальність крізь різні лінзи й дзеркала. Кожне щось відкриває — і кожне може приховати те, що лишилося поза рамкою.",
      "ru": "Мы встречаем одну реальность через разные линзы и зеркала. Каждое что-то открывает — и каждое может скрыть то, что осталось за рамкой."
    }
  },
  "parts": {
    "seeing": {
      "file": "part-seeing.webp",
      "alt": {
        "en": "A kneeling observer, shown full-length, studies a stone through a magnifying lens and takes notes; faint possible shadows diverge from the stone, and a red thread is tied to it.",
        "uk": "Спостерігач, зображений на повний зріст навколішки, вивчає камінь крізь лупу й робить нотатки; від каменя розходяться слабкі можливі тіні, а до нього прив’язана червона нитка.",
        "ru": "Наблюдатель, изображённый в полный рост на коленях, изучает камень через лупу и делает записи; от камня расходятся слабые возможные тени, а к нему привязана красная нить."
      },
      "caption": {
        "en": "Interpretations multiply, but each remains answerable to the trace that resisted our wishes.",
        "uk": "Тлумачення множаться, але кожне має відповідати перед слідом, який не підкорився нашим бажанням.",
        "ru": "Толкования множатся, но каждое должно отвечать перед следом, который не подчинился нашим желаниям."
      }
    },
    "choosing": {
      "file": "part-choosing.webp",
      "alt": {
        "en": "An observer holds a finite spool of red thread and passes it through one of two brass openings, leaving the other unused.",
        "uk": "Спостерігач тримає обмежену котушку червоної нитки й проводить її крізь один із двох латунних отворів, залишаючи інший невикористаним.",
        "ru": "Наблюдатель держит ограниченную катушку красной нити и проводит её через одно из двух латунных отверстий, оставляя другое неиспользованным."
      },
      "caption": {
        "en": "Choice makes one path real by spending a finite resource and leaving another path untaken.",
        "uk": "Вибір робить один шлях реальним, витрачаючи обмежений ресурс і залишаючи інший шлях непройденим.",
        "ru": "Выбор делает один путь реальным, расходуя ограниченный ресурс и оставляя другой путь непройденным."
      }
    },
    "relations": {
      "file": "part-relations.webp",
      "alt": {
        "en": "Two people stand on unequal platforms while a red thread passes through a brass ring and supports a shared lamp.",
        "uk": "Двоє людей стоять на нерівних платформах, а червона нитка проходить крізь латунне кільце й підтримує спільну лампу.",
        "ru": "Два человека стоят на неравных платформах, а красная нить проходит через латунное кольцо и поддерживает общую лампу."
      },
      "caption": {
        "en": "Relations are shaped not only by intentions, but also by positions, rules, and who bears the weight.",
        "uk": "Відносини визначають не лише наміри, а й позиції, правила та те, на кому лежить тягар.",
        "ru": "Отношения определяют не только намерения, но и позиции, правила и то, на ком лежит тяжесть."
      }
    },
    "learning": {
      "file": "part-learning.webp",
      "alt": {
        "en": "A researcher, shown full-length, adjusts a simple recording instrument; a red line records its oscillation and continues to a reference weight.",
        "uk": "Дослідник, зображений на повний зріст, налаштовує простий реєструвальний прилад; червона лінія записує його коливання й продовжується до еталонного вантажу.",
        "ru": "Исследователь, изображённый в полный рост, настраивает простой регистрирующий прибор; красная линия записывает его колебание и продолжается к эталонному грузу."
      },
      "caption": {
        "en": "Learning begins when feedback is allowed to correct the instrument, not merely decorate its report.",
        "uk": "Навчання починається тоді, коли зворотному зв’язку дозволено виправляти інструмент, а не лише прикрашати його звіт.",
        "ru": "Обучение начинается тогда, когда обратной связи разрешено исправлять инструмент, а не только украшать его отчёт."
      }
    },
    "consequences": {
      "file": "part-consequences.webp",
      "alt": {
        "en": "An observer turns a wheel that opens a distant gate while the same mechanism rotates the platform beneath them.",
        "uk": "Спостерігач повертає колесо, що відчиняє далекі ворота, тоді як той самий механізм обертає платформу під його ногами.",
        "ru": "Наблюдатель вращает колесо, открывающее далёкие ворота, тогда как тот же механизм поворачивает платформу под его ногами."
      },
      "caption": {
        "en": "Action changes both the world and the position from which the actor will make the next decision.",
        "uk": "Дія змінює і світ, і позицію, з якої діяч ухвалюватиме наступне рішення.",
        "ru": "Действие меняет и мир, и позицию, с которой действующий будет принимать следующее решение."
      }
    },
    "limits": {
      "file": "part-limits.webp",
      "alt": {
        "en": "Two people meet beside a quiet sea; a red thread leaves a folded map and ends where their hands touch.",
        "uk": "Двоє людей зустрічаються біля тихого моря; червона нитка виходить зі складеної мапи й закінчується там, де торкаються їхні руки.",
        "ru": "Два человека встречаются у тихого моря; красная нить выходит из сложенной карты и заканчивается там, где соприкасаются их руки."
      },
      "caption": {
        "en": "When the map ends and control narrows, presence, care, and dignity remain real forms of action.",
        "uk": "Коли мапа закінчується, а контроль звужується, присутність, турбота й гідність залишаються реальними формами дії.",
        "ru": "Когда карта заканчивается, а контроль сужается, присутствие, забота и достоинство остаются реальными формами действия."
      }
    }
  },
  "essays": {
    "map-knows-it-is-map": {
      "file": "essay-01-depth.webp",
      "alt": {
        "en": "A woman cartographer in a small survey boat checks a map while lowering a vertical red sounding line through the water to an irregular submerged rock.",
        "uk": "Жінка-картограф у невеликому дослідницькому човні звіряє мапу й опускає вертикальну червону нитку-лот крізь воду до нерівної підводної скелі.",
        "ru": "Женщина-картограф в небольшой исследовательской лодке сверяет карту и опускает вертикальную красную нить-лот сквозь воду к неровной подводной скале."
      },
      "caption": {
        "en": "A map becomes trustworthy when it leaves reality a path to correct it.",
        "uk": "Мапа заслуговує на довіру, коли допускає, що реальність може виправити саму мапу.",
        "ru": "Карта заслуживает доверия, когда допускает, что реальность может исправить саму карту."
      }
    },
    "power-to-define-reality": {
      "file": "essay-02-visibility.webp",
      "alt": {
        "en": "A person holds a red thread beside a brass frame; the thread passes through the frame to a seed on the right, drawing it out of a rectangular shadow toward the light.",
        "uk": "Людина тримає червону нитку біля латунної рамки; нитка проходить крізь рамку до насінини праворуч і витягує її з прямокутної тіні до світла.",
        "ru": "Человек держит красную нить возле латунной рамки; нить проходит через рамку к семени справа и вытягивает его из прямоугольной тени к свету."
      },
      "caption": {
        "en": "Power begins before the decision, in the frame that decides what can appear.",
        "uk": "Влада починається ще до рішення — у рамці, яка визначає, що може з’явитися.",
        "ru": "Власть начинается ещё до решения — в рамке, которая определяет, что может появиться."
      }
    },
    "world-is-not-made-of-games": {
      "file": "essay-03-games.webp",
      "alt": {
        "en": "A seated person guides a red thread along the rectangular grid of a game board, then receives its free curve in an open hand beyond the board’s edge.",
        "uk": "Людина сидить і веде червону нитку прямокутною сіткою ігрової дошки, а за краєм дошки приймає її вільну криву у відкриту долоню.",
        "ru": "Сидящий человек ведёт красную нить по прямоугольной сетке игровой доски, а за краем доски принимает её свободную кривую в открытую ладонь."
      },
      "caption": {
        "en": "A game is a structure within life, not the name of life as a whole.",
        "uk": "Гра — це структура всередині життя, а не назва життя загалом.",
        "ru": "Игра — это структура внутри жизни, а не название жизни в целом."
      }
    },
    "strategy-as-refusal": {
      "file": "essay-04-refusal.webp",
      "alt": {
        "en": "A traveller carrying a spool walks toward the central one of three brass arches; the red thread leads only to the central arch, leaving the other two unchosen.",
        "uk": "Мандрівник із котушкою йде до центральної з трьох латунних арок; червона нитка веде лише до центральної арки, залишаючи дві інші невибраними.",
        "ru": "Путешественник с катушкой идёт к центральной из трёх латунных арок; красная нить ведёт только к центральной арке, оставляя две другие невыбранными."
      },
      "caption": {
        "en": "Strategy makes one direction real by accepting the paths it will not take.",
        "uk": "Стратегія робить один напрям реальним, приймаючи шляхи, якими вона не піде.",
        "ru": "Стратегия делает одно направление реальным, принимая пути, по которым она не пойдёт."
      }
    },
    "victory-changes-winner": {
      "file": "essay-05-victory.webp",
      "alt": {
        "en": "A person passes through a laurel ring; a red thread winds around both the ring and the person’s wrist, then changes direction.",
        "uk": "Людина проходить крізь лаврове кільце; червона нитка обвиває і кільце, і зап’ястя людини, а потім змінює напрям.",
        "ru": "Человек проходит через лавровое кольцо; красная нить обвивает и кольцо, и запястье человека, а затем меняет направление."
      },
      "caption": {
        "en": "Victory does not end causality; it changes the forces acting on the winner.",
        "uk": "Перемога не припиняє причинність; вона змінює сили, що діють на переможця.",
        "ru": "Победа не прекращает причинность; она меняет силы, действующие на победителя."
      }
    },
    "there-is-no-last-arena": {
      "file": "essay-06-last-arena.webp",
      "alt": {
        "en": "A kneeling person uses a red thread to stitch a tear at the boundary of a broken circle.",
        "uk": "Людина навколішки червоною ниткою зшиває розрив біля межі зламаного кола.",
        "ru": "Человек на коленях красной нитью сшивает разрыв у границы сломанного круга."
      },
      "caption": {
        "en": "Where winning ceases to describe reality, care and witness still have work to do.",
        "uk": "Там, де перемога перестає описувати реальність, турбота й свідчення все ще мають свою роботу.",
        "ru": "Там, где победа перестаёт описывать реальность, у заботы и свидетельства всё ещё остаётся работа."
      }
    }
  },
  "chapterParts": {
    "reality": "seeing",
    "uncertainty": "seeing",
    "systems": "seeing",
    "visibility": "seeing",
    "freedom": "choosing",
    "plural-values": "choosing",
    "strategy": "choosing",
    "risk": "choosing",
    "games": "relations",
    "cooperation": "relations",
    "institutions": "relations",
    "narrative-status": "relations",
    "expertise": "learning",
    "organizational-learning": "learning",
    "victory": "consequences",
    "power-blindness": "consequences",
    "limits": "limits",
    "finitude": "limits"
  }
}
